import { render } from "./framework.vue?vue&type=template&id=d2ad79ec"
import script from "./framework.vue?vue&type=script&lang=js"
export * from "./framework.vue?vue&type=script&lang=js"

import "./framework.vue?vue&type=style&index=0&id=d2ad79ec&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__